import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import { SERVICE_BOOKING_PATH, queryClient } from '@/services'

export const useUpdateBookingRepair = (tokenId, verifyCode, config = {}) => {
  const api = useLegacyPublicApi()
  const { formatMessage } = useIntl()
  const [errorMessage, setErrorMessage] = useState(null)

  const { mutateAsync: mutate, isLoading } = useMutation({
    mutationFn: async (requestData) => {
      if (
        !api ||
        !requestData ||
        !tokenId ||
        !requestData.timeSlotId ||
        !requestData.date
      )
        return false
      setErrorMessage(null)
      const { data } = await api.post(
        SERVICE_BOOKING_PATH.replace('{tokenId}', tokenId),
        requestData,
      )
      return data
    },
    onSuccess: (data) => {
      queryClient.setQueryData(
        ['get-booking-repair-token', tokenId, verifyCode],
        data,
      )
      return null
    },
    onError: (error) => {
      if (error)
        setErrorMessage(
          formatMessage({ id: 'page.bookingWizard.update-error' }),
        )
    },
    ...config,
  })

  const updateBookingRepairTokenData = (data) => mutate(data)
  return { updateBookingRepairTokenData, isLoading, errorMessage }
}

export default useUpdateBookingRepair
